import React from "react";
import { Th as ChakraTh } from "@chakra-ui/react";

export const Th = props => {
	return <ChakraTh fontSize="1.2em" {...props} />;
};
